<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ $t('users.title') }}</h1>
    <br>
    <!-- <v-toolbar color="primary" dark>
      <v-app-bar-nav-icon />
      <v-toolbar-title>{{ $t('users.title') }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        @click="handleAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar> -->
    <custom-table
      title="users.title"
      icon="mdi-account-multiple"
      :headers="[{
          text: $t('users.name'),
          align: 'left',
          sortable: false,
          value: 'ident',
        },
        { text: $t('users.email'), value: 'email' },
      ]"
      :data="data"
      :count="count"
      :loading="loading"
      :onAdd="handleAdd"
      :onSearch="handleChangeSearch"
    />
  </v-card>
</template>

<script>
  import api from '@/services/api'
  import CustomTable from '@/components/CustomTable'
  export default {
    components: {
      CustomTable
    },
    data: () => ({
      page: 1,
      count: 0,
      itemPerPage: 10,
      searchValue: '',
      data: [],
      loading: false
    }),
    mounted () {
      this.handleGetUser()
    },
    methods: {
      handleChangeSearch (searchValue, page) {
        this.searchValue = searchValue
        this.page = page
        this.handleGetUser()
      },
      handleGetUser () {
        this.loading = true
        api.getAll('users', true, this.page, this.itemPerPage, this.searchValue).then(response => {
          this.count = response.count
          this.data = response.data.map(item => {
            return ({
              ident: {
                id: item.ID,
                name: item.Name
              },
              email: item.Email
            })
          })
          this.loading = false
        })
      },
      handleAdd () {
        this.$router.push('/users/new')
      }
    }
  }
</script>
